import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/screens/NotFound/images/not-found.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/Button/Button.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/screens/NotFound/ui/NotFound.module.scss");
